import Vue from 'vue'
import Router from 'vue-router'
import {store} from '@/_store'

Vue.use(Router);

// Lazy Loading Routes
//https://router.vuejs.org/guide/advanced/lazy-loading.html#grouping-components-in-the-same-chunk
const LogInUser = () => import(/* webpackChunkName: "login" */ '../views/user/LogInUser');
const LogInPassword = () => import(/* webpackChunkName: "login" */ '../views/user/LogInPassword');
const AppLayout = () => import(/* webpackChunkName: "layout" */ '../layouts/AppLayout');
const Home = () => import(/* webpackChunkName: "home" */ '../views/base/Home');
const User = () => import(/* webpackChunkName: "user" */ '../views/user/User');
const UserRegister = () => import(/* webpackChunkName: "user" */ '../views/user/UserRegister');
const UserChangePassword = () => import(/* webpackChunkName: "user" */ '../views/user/UserChangePassword');
const QRCode = () => import(/* webpackChunkName: "qrcode" */ '../views/base/QRCode');
const Highlights = () => import(/* webpackChunkName: "highlights" */ '../views/modules/Highlights');
const Stores = () => import(/* webpackChunkName: "stores" */ '../views/stores/Stores');
const StoresList = () => import(/* webpackChunkName: "stores" */ '../views/stores/StoresList');
const StoresMaps = () => import(/* webpackChunkName: "stores" */ '../views/stores/StoresMaps');
const StoreDetail = () => import(/* webpackChunkName: "stores" */ '../views/stores/StoreDetail');
const Campaigns = () => import(/* webpackChunkName: "campaigns" */ '../views/modules/Campaigns');
const Purchases = () => import(/* webpackChunkName: "purchases" */ '../views/modules/Purchases');
const PurchaseDetail = () => import(/* webpackChunkName: "purchases" */ '../views/modules/PurchaseDetail');
const LoyaltyMovements = () => import(/* webpackChunkName: "purchases" */ '../views/modules/LoyaltyMovements');
const Offers = () => import(/* webpackChunkName: "offers" */ '../views/modules/Offers');
const InfoOptions = () => import(/* webpackChunkName: "offers" */ '../views/info/InfoOptions');
const Info = () => import(/* webpackChunkName: "offers" */ '../views/info/Info');
const Support = () => import(/* webpackChunkName: "offers" */ '../views/info/Support');
const Settings = () => import(/* webpackChunkName: "settings" */ '../views/base/Settings');
const NotFoundView = () => import(/* webpackChunkName: "notfound" */ '../components/404');
const TermsPolicy = () => import(/* webpackChunkName: "offers" */ '../views/info/TermsPolicy');
const ShoppingCart = () => import(/* webpackChunkName: "settings" */ '../views/shop/OrderStepCart');
const Catalog = () => import(/* webpackChunkName: "settings" */ '../views/shop/Catalog');
const CatalogGroupDetail = () => import(/* webpackChunkName: "settings" */ '../views/shop/CatalogGroupDetail');
const CatalogItemDetail = () => import(/* webpackChunkName: "settings" */ '../views/shop/CatalogItemDetail');
const CatalogItemDetailMenu = () => import(/* webpackChunkName: "settings" */ '../views/shop/CatalogItemDetailMenu');
const DeliveryOptions = () => import(/* webpackChunkName: "settings" */ '../views/shop/OrderStepDelivery');
const DeliveryResume = () => import(/* webpackChunkName: "settings" */ '../views/shop/OrderStepResume');
const PaymentOptions = () => import(/* webpackChunkName: "settings" */ '../views/shop/OrderStepPayment');
const OrderCompleted = () => import(/* webpackChunkName: "settings" */ '../views/shop/OrderCompleted');
const Orders = () => import(/* webpackChunkName: "settings" */ '../views/shop/Orders');
const OrdersDetail = () => import(/* webpackChunkName: "orders" */ '../views/shop/OrdersDetail');
const SearchResults = () => import(/* webpackChunkName: "orders" */ '../views/shop/SearchResults');


export const router = new Router({
        mode: 'history',
        base: process.env.BASE_URL,

        // All the routes of our project
        // https://router.vuejs.org/guide/
        // https://router.vuejs.org/guide/advanced/meta.html
        routes: [
            {
                path: '/login', name: 'login', component: LogInUser, context: 'general'
            }, {
                path: '/login/auth/:status', name: 'login-auth', component: LogInPassword, context: 'general'
            }, {
                path: '/user/register', name: 'user-register', component: UserRegister, context: 'general'
            }, {
                path: '/', name: 'root', component: AppLayout,
                children: [
                    // {
                    //     path: '/user',
                    //     name: 'user',
                    //     // route level code-splitting
                    //     // this generates a separate chunk (about.[hash].js) for this route
                    //     // which is lazy-loaded when the route is visited.
                    //     component: () => import(/* webpackChunkName: "user" */ './views/User.vue')
                    // },
                    {
                        path: '/home',
                        name: 'home',
                        component: Home,
                        meta: {toolbarTitle: '$vuetify.home', parentMenuPath: '/home', context: 'general'}
                    }, {
                        path: '/user',
                        name: 'user',
                        component: User,
                        meta: {toolbarTitle: '$vuetify.user', parentMenuPath: '/user', context: 'general'}
                    }, {
                        path: '/user/changepassword',
                        name: 'user-change-password',
                        component: UserChangePassword,
                        meta: {toolbarTitle: '$vuetify.user', parentMenuPath: '/user', context: 'general'},
                    }, {
                        path: '/qrcode',
                        name: 'qrcode',
                        component: QRCode,
                        meta: {toolbarTitle: '$vuetify.qrcode', parentMenuPath: '/qrcode', context: 'general'}
                    }, {
                        path: '/highlights',
                        name: 'highlights',
                        component: Highlights,
                        meta: {toolbarTitle: '$vuetify.highlights', parentMenuPath: '/highlights', context: 'general'}
                    }, {
                        path: '/stores',
                        name: 'stores',
                        component: Stores,
                        meta: {toolbarTitle: '$vuetify.stores', parentMenuPath: '/stores', context: 'general'},
                        children:
                            [
                                {
                                    path: '/stores/list',
                                    name: 'stores-list',
                                    component: StoresList,
                                    meta: {
                                        toolbarTitle: '$vuetify.stores',
                                        parentMenuPath: '/stores/list',
                                        context: 'general'
                                    },
                                },
                                {
                                    path: '/stores/maps',
                                    name: 'stores-maps',
                                    component: StoresMaps,
                                    meta: {toolbarTitle: '$vuetify.stores', parentMenuPath: '/stores', context: 'general'},
                                },
                                {
                                    path: '/stores/:id',
                                    name: 'stores-detail',
                                    component: StoreDetail,
                                    meta: {
                                        toolbarTitle: '$vuetify.stores',
                                        parentMenuPath: '/stores/list',
                                        context: 'general'
                                    },
                                }
                            ]
                    }, {
                        path: '/campaigns',
                        name: 'campaigns',
                        component: Campaigns,
                        meta: {toolbarTitle: '$vuetify.campaigns', parentMenuPath: '/campaigns', context: 'general'},
                    }, {
                        path: '/purchases',
                        name: 'purchases',
                        component: Purchases,
                        meta: {toolbarTitle: '$vuetify.transactions', parentMenuPath: '/purchases', context: 'general'},
                    }, {
                        path: '/loyaltymovements',
                        name: 'loyaltymovements',
                        component: LoyaltyMovements,
                        meta: {toolbarTitle: '$vuetify.transactions', parentMenuPath: '/loyaltymovements', context: 'general'},
                    }, {
                        path: '/purchases/:id',
                        name: 'purchases-detail',
                        component: PurchaseDetail,
                        meta: {
                            toolbarTitle: '$vuetify.transactions_detail',
                            parentMenuPath: '/purchases',
                            context: 'general'
                        },
                    }, {
                        path: '/offers',
                        name: 'offers',
                        component: Offers,
                        meta: {toolbarTitle: '$vuetify.offers', parentMenuPath: '/offers', context: 'general'},
                    }, {
                        path: '/settings',
                        name: 'settings',
                        component: Settings,
                        meta: {toolbarTitle: "$vuetify.settings", parentMenuPath: '/settings', context: 'general'},
                    }, {
                        path: '/info',
                        name: 'info',
                        component: Info,
                        meta: {toolbarTitle: '$vuetify.info', parentMenuPath: '/info', context: 'general'},
                        children:
                            [
                                {
                                    path: '/info/options',
                                    name: 'info-options',
                                    component: InfoOptions,
                                    meta: {
                                        toolbarTitle: '$vuetify.support',
                                        parentMenuPath: '/info/options',
                                        context: 'general'
                                    },
                                },
                                {
                                    path: '/info/support',
                                    name: 'info-support',
                                    component: Support,
                                    meta: {
                                        toolbarTitle: '$vuetify.support',
                                        parentMenuPath: '/info/options',
                                        context: 'general'
                                    },
                                },

                            ]
                    }, {
                        path: '/termspolicy',
                        name: 'terms-policy',
                        component: TermsPolicy,
                        meta: {
                            toolbarTitle: '$vuetify.gdpr_agreement.program_terms_policy',
                            parentMenuPath: '/termspolicy',
                            context: 'general'
                        },
                    }, {
                        path: '/orders',
                        name: 'orders',
                        component: Orders,
                        meta: {toolbarTitle: '$vuetify.shop.my_orders', parentMenuPath: 'order', context: 'shop'}
                    }, {
                        path: '/orders/:id',
                        name: 'orders-detail',
                        component: OrdersDetail,
                        meta: {toolbarTitle: '$vuetify.transactions_detail', parentMenuPath: '/orders', context: 'shop'},
                    },
                    {
                        path: '/order/cart',
                        name: 'order-cart',
                        component: ShoppingCart,
                        meta: {toolbarTitle: '$vuetify.shop.shop_cart', parentMenuPath: '/order/cart', context: 'shop'}
                    }, {
                        path: '/order/delivery',
                        name: 'order-delivery',
                        component: DeliveryOptions,
                        meta: {
                            toolbarTitle: '$vuetify.shop.shipping_method',
                            parentMenuPath: '/order/cart',
                            context: 'shop'
                        }
                    }, {
                        path: '/order/resume',
                        name: 'order-resume',
                        component: DeliveryResume,
                        meta: {toolbarTitle: '$vuetify.shop.order_resume', parentMenuPath: '/order/cart', context: 'shop'}
                    }, {
                        path: '/order/pay',
                        name: 'order-pay',
                        component: PaymentOptions,
                        meta: {toolbarTitle: '$vuetify.shop.order_pay', parentMenuPath: '/order/cart', context: 'shop'}
                    },{
                        path: '/order/complete',
                        name: 'order-complete',
                        component: OrderCompleted,
                        meta: {toolbarTitle: '', parentMenuPath: '/order/cart', context: 'shop'}
                    },{
                        path: '/catalog',
                        name: 'catalog',
                        component: Catalog,
                        meta: {toolbarTitle: '$vuetify.shop.catalog', parentMenuPath: '/catalog', context: 'shop'}
                    },{
                        path: '/catalog/search',
                        name: 'shop-search-results',
                        component: SearchResults,
                        meta: {toolbarTitle: '$vuetify.shop.catalog', parentMenuPath: '/catalog', context: 'shop'},
                    },{
                        path: '/catalog/item/:id',
                        name: 'shop-item-detail',
                        component: CatalogItemDetail,
                        meta: {toolbarTitle: '$vuetify.shop.catalog', parentMenuPath: '/catalog', context: 'shop'},
                    }, {
                        path: '/catalog/:id',
                        name: 'shop-group-detail',
                        component: Catalog,
                        meta: {toolbarTitle: '$vuetify.shop.catalog', parentMenuPath: '/catalog', context: 'shop'}
                    }, {
                        path: '/catalog/group/:group',
                        name: 'shop-group-detail-items',
                        component: CatalogGroupDetail,
                        meta: {toolbarTitle: '$vuetify.shop.catalog', parentMenuPath: '/catalog', context: 'shop'},
                    },{
                        path: '/catalog/item/menu/:id',
                        name: 'shop-item-detail-menu',
                        component: CatalogItemDetailMenu,
                        meta: {toolbarTitle: '$vuetify.shop.catalog', parentMenuPath: '/catalog', context: 'shop'},
                    },
                ]
            },
            {
                // not found handler
                path: '*',
                component: NotFoundView
            }
        ]
    })
;

router.beforeEach(async(to, from, next) => {
    /**
     * https://router.vuejs.org/guide/advanced/navigation-guards.html
     * A Navigation Guard
     * Redirect to login page if not logged in and trying to access a restricted page
     * Redirect to profile page if user is logged in but has not accepted the terms and conditions
     * Redirect to the Home page if the Shop's module is not available and the user is trying to access a page related
     *  to the Shop's module
     *
     * @param to: the target Route Object being navigated to
     * @param from: the current route being navigated away from
     * @param next: a function
     */
    Vue.$log.debug("Router Navigation Guard | To Name :" + to.name + " | To Context : " + to.meta.context);
    const publicPages = ['login', 'login-auth', 'user-register', 'terms-policy'];
    const authRequired = !publicPages.includes(to.name);
    const loggedIn = localStorage.getItem('user');

    //The storage has two attributes which have a direct effect on the routers:
    // 1 - an attribute which identifies whether or not the user has to validate his profile;
    // 2 - an attribute which identifies whether or not the user has to set a new password.
    // Here, these attributes are checked every time a new URL is "called". This way we prevent the user from accessing views
    //  not available since the acceptance of the TC is not yet validated or since the password has not been changed.
    let validateProfile = false;
    let changePassword = false;
    await store.dispatch('configs/initGeneralConfig');
    //let shopAvailable = store.getters['configs/shopAvailable'];
    let shopAvailable = false;
    if (loggedIn) {
        let user = JSON.parse(loggedIn);
        if (user && user.mandatoryValidateProfile === 1)
            validateProfile = true;

        if (user && user.mandatoryChangePassword === 1)
            changePassword = true;
    }

    Vue.$log.debug("Router Navigation Guard | User ainda obrigado a validar TC? " + validateProfile);
    Vue.$log.debug("Router Navigation Guard | User ainda obrigado a alterar password? " + changePassword);
    Vue.$log.debug("Router Navigation Guard | Módulo Loja Online Disponível? " + shopAvailable);

    // 1 - The user is accessing a page which requires a valid login, but the user is not logged in:
    //  -> redirecting to the Login Page
    if (authRequired && !loggedIn) {
        return next('/login');
    }
    // 2 - The user is accessing a page which requires a valid login, the user is logged in,
    // 2.1 - but the user hadn't yet changed his password
    //      -> redirecting to the Change Password Page
    else if (authRequired && changePassword && to.name !== "user-change-password" && to.name !== 'logout') {
        return next('/user/changepassword');
    }
    // 2.2 - but the user hadn't yet accepted the terms and conditions
    //      -> redirecting to the Profile Page
    else if (authRequired && validateProfile && to.name !== "user" && to.name !== 'logout') {
        //If the user also has to change its password, 1st the user must change it
        if (changePassword && to.name === 'user-change-password') {
            next();
        } else {
            return next('/user');
        }
    } else if (to.path === "/") {
        return next('/home');
    }

    // 3. The user is accessing a page related to the Shop's module, but the module is not available
    //      -> redirecting to the Home page
    if (to.meta.context === 'shop' && shopAvailable === false) {
        return next('/home');
    }

    next();
});